import FaqList from '../components/FaqList'
import PageHero from '../components/PageHero'
import SEO from '../components/SEO'
import SectionHeading from '../components/SectionHeading'
import { faqStructuredData } from '../config/schema'
import { faqs } from '../data/site'

export default function Faq() {
  return (
    <>
      <SEO page="faqs" structuredData={faqStructuredData} />
      <PageHero index="05" eyebrow="FAQs" title="Frequently asked questions" description="Helpful details for clients and independent professionals." image="Home-banner-slider.webp" imagePosition="52% center" />
      <section className="section section--soft">
        <div className="container narrow-container">
          <SectionHeading index="01" eyebrow="Answers" title="Plan your visit with confidence" align="center" />
          <FaqList items={faqs} />
        </div>
      </section>
    </>
  )
}
